export default "__VITE_ASSET__aK6ymeXU__"